import { SharedSettings } from 'settings/SharedSettings'

export const getScreenSize = (width: number = window.innerWidth, height: number = window.innerHeight) => {
  return {
    isWideScreen: width > SharedSettings.MINIMUM_WIDTH_WIDE_SCREEN,
    screenWidth: width,
    screenHeight: height,
  }
}
